import React from 'react'
import { useForm } from 'react-hook-form'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { API_FUNCTIONS } from '../utils/apiFunctions'
import { TOASTS } from '../utils/toasts'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'

export default function Contact() {
  const { register, handleSubmit, formState: { errors }, reset } = useForm()

  const sendMessage = async (data) => {
    try {
      const response = await API_FUNCTIONS.sendMessage(data)
      if (response.data?.code === 200) {
        reset()
        TOASTS.success('Votre message a bien été envoyé. Nous vous recontacterons dans les meilleurs délais.')
      } else {
        TOASTS.error("Oups, une erreur est survenue lors de l'envoi de votre message...")
      }
    } catch (e) {
      TOASTS.error("Oups, une erreur est survenue lors de l'envoi de votre message...")
    }
  }

  return (
    <div className="landing" style={{ minHeight: '100vh', padding: '2rem' }}>
      <Helmet>
        <title>Contact — CloudyPocket</title>
      </Helmet>

      <div style={{ maxWidth: '600px', margin: '4rem auto' }}>
        <Link to="/" style={{ color: 'var(--dark-text-low)', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '0.5rem', marginBottom: '2rem', fontSize: '0.9rem' }}>
          <FontAwesomeIcon icon={faArrowLeft} /> Retour à l'accueil
        </Link>

        <h1 className="section-title" style={{ textAlign: 'left', marginBottom: '0.5rem' }}>Nous contacter</h1>
        <p className="section-subtitle" style={{ textAlign: 'left', margin: '0 0 2rem' }}>
          Remplissez le formulaire ci-dessous et nous vous recontacterons le plus rapidement possible.
        </p>

        <form onSubmit={handleSubmit(sendMessage)} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <div>
            <label htmlFor="contactEmail" style={{ display: 'block', marginBottom: '0.375rem', fontSize: '0.9rem', color: 'var(--dark-text-low)' }}>Votre email</label>
            <input
              type="email"
              id="contactEmail"
              {...register('email', { required: 'Ce champ est obligatoire' })}
              style={{ width: '100%', padding: '0.75rem', borderRadius: '8px', border: '1px solid var(--dark-border)', background: 'var(--dark-element)', color: 'var(--dark-text-high)', fontSize: '0.9rem' }}
            />
            {errors.email && <span style={{ color: 'var(--dark-danger)', fontSize: '0.8rem' }}>{errors.email.message}</span>}
          </div>

          <div>
            <label htmlFor="contactMessage" style={{ display: 'block', marginBottom: '0.375rem', fontSize: '0.9rem', color: 'var(--dark-text-low)' }}>Votre message</label>
            <textarea
              id="contactMessage"
              rows={6}
              {...register('message', { required: 'Vous ne pouvez pas envoyer un message vide' })}
              style={{ width: '100%', padding: '0.75rem', borderRadius: '8px', border: '1px solid var(--dark-border)', background: 'var(--dark-element)', color: 'var(--dark-text-high)', fontSize: '0.9rem', resize: 'vertical' }}
            />
            {errors.message && <span style={{ color: 'var(--dark-danger)', fontSize: '0.8rem' }}>{errors.message.message}</span>}
          </div>

          <button
            type="submit"
            style={{ padding: '0.75rem 2rem', borderRadius: '8px', background: 'var(--dark-solid)', color: '#fff', border: 'none', fontSize: '0.95rem', fontWeight: '600', cursor: 'pointer', alignSelf: 'flex-start' }}
          >
            Envoyer
          </button>
        </form>
      </div>
    </div>
  )
}
